
import React, { useEffect, useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import useCsrfToken from '../hooks/useCsrfToken';

export default function SliderPromos() {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);
    var slides = 4;
    var infinite = true;
    var arrows = true;
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const transformData = (data) => {
            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Paquetes',
                name: data.title,
                slug: data.slug
            };
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/packages-slider`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    if (data.length && !data.error) {
                        const transformedListings = data.map(item => transformData(item));
                        setListings(transformedListings);
                    }

                })
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [csrfToken]);
    if (listings.length < 4) {
        slides = listings.length;
        infinite = true;
    } else {
        slides = 4;
        infinite = true;
    }
    if (listings.length < 3) {
        slides = 2;
        infinite = false;
        arrows = false;
    }
    const settings = {
        arrows: arrows,
        dots: false,
        infinite: infinite,
        speed: 500,
        slidesToShow: slides,
        slidesToScroll: slides,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className="col-12 slider-container">
            {listings.length > 0 && (
                <Slider {...settings}>
                    {listings.map((item) => {
                        return (
                            <div key={item.id}>
                                <Link to={`/paquete/${item.slug}`} className="text-dark title h5" key={item.id}>
                                    <img src={item.image} alt={item.title} className=" p-2 w-6 shadow-2 img-fluid" />
                                </Link>
                            </div>
                        );
                    })}
                </Slider>
            )}
        </div>
        // <div className=''>
        //     <Carousel value={products} autoplayInterval={5000} numVisible={3} numScroll={3} responsiveOptions={responsiveOptions} itemTemplate={productTemplate} />
        // </div>
    )
}